"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6416],{

/***/ 16416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ShareIcons; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16573);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1020);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12834);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69275);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61366);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94493);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45533);





var shareButtonsCommonProps = {
    // buttonProps: { className: 'share-project__share-button' },
    iconProps: {
        // className: 'share-project__share-icon',
        path: "",
        round: true,
        size: 46
    }
};
function ShareIcons(param) {
    var productImage = param.productImage, productUrl = param.productUrl;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_1__/* .ShareIconsWrapper */ .Sj, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                url: productUrl,
                quote: intl.formatMessage({
                    defaultMessage: "RENO doors - sliding doors with unforgetable style",
                    id: "T4MmA0"
                }),
                hashtag: intl.formatMessage({
                    defaultMessage: "#renodoors",
                    id: "SroRrm"
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, shareButtonsCommonProps.iconProps))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                url: productUrl,
                title: intl.formatMessage({
                    defaultMessage: "RENO doors",
                    id: "q6VJYI"
                }),
                separator: intl.formatMessage({
                    defaultMessage: " - sliding doors with unforgetable style",
                    id: "Dh6zcM"
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, shareButtonsCommonProps.iconProps))
            }),
            productImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                url: productUrl,
                media: productImage,
                description: intl.formatMessage({
                    defaultMessage: "Sliding doors with unforgetable style, best qaulity and wide choice of sizes and colors  - find your #RENOdoors",
                    id: "KztajJ"
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, shareButtonsCommonProps.iconProps))
            })
        ]
    });
}


/***/ }),

/***/ 45533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ Right; },
/* harmony export */   "Om": function() { return /* binding */ SaveSelect; },
/* harmony export */   "P$": function() { return /* binding */ SaveSelectText; },
/* harmony export */   "Pp": function() { return /* binding */ ProductCategory; },
/* harmony export */   "RG": function() { return /* binding */ SaveSelectIcon; },
/* harmony export */   "Sj": function() { return /* binding */ ShareIconsWrapper; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "dg": function() { return /* binding */ SaveSelectLoader; },
/* harmony export */   "dv": function() { return /* binding */ Left; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "k$": function() { return /* binding */ SaveButton; },
/* harmony export */   "qN": function() { return /* binding */ ProductImage; },
/* harmony export */   "tc": function() { return /* binding */ ProductTitle; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "ws": function() { return /* binding */ ContentWishlist; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports Image, Title */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23042);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52015);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-width: 930px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    max-width: initial;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  display: flex;\n  max-width: 1120px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    flex-direction: column;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        top: -18px;\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        top: 0;\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: 14px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 82px 67px 84px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    padding: 70px;\n    max-width: 330px;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 36px 20px 50px;\n    max-width: initial;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 80px;\n  & > p {\n    text-align: center;\n    position: relative;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    margin: ",
        ";\n    width: 80%;\n    &:before {\n      content: '';\n      display: block;\n      width: 110%;\n      height: 1px;\n      left: -14px;\n      top: -35px;\n      position: absolute;\n      background-color: #b9c5cb;\n      opacity: 0.5;\n      ",
        "\n      ",
        "\n    }\n    ",
        "\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    position: relative;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-top: 37px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " {\n    height: 35vh;\n    padding-bottom: 18px;\n    flex-shrink: 0;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: calc(",
        " * 4);\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 62px;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 46px;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: auto;\n    height: 72px;\n    margin-bottom: 0;\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: 36px;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: 30px;\n    margin-bottom: 50px;\n    width: 50%;\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    margin-top: 27px;\n    margin-bottom: 32px;\n    line-height: 100%;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-family: ",
        ";\n  margin-top: 38px;\n  margin-bottom: ",
        ";\n  text-align: center;\n  line-height: 120%;\n  width: 100%;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-bottom: ",
        ";\n    width: 50%;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: 0;\n    margin-bottom: ",
        ";\n    width: 100%;\n  "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " {\n    margin-bottom: ",
        ";\n    line-height: 120%;\n  "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n  width: 75%;\n  opacity: 0.8;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 100%;\n    width: auto;\n  "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 60%;\n  mix-blend-mode: darken;\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 75%;\n  "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: absolute;\n    bottom: 60px;\n  "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 85%;\n    bottom: 30px;\n  "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 60%;\n  position: relative;\n  font-size: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 75%;\n  "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: absolute;\n    bottom: 90px;\n  "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 85%;\n    line-height: 160%;\n    margin-bottom: 0;\n    bottom: 60px;\n  "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 60%;\n  position: relative;\n  text-transform: capitalize;\n  font-family: ",
        ";\n  font-family: ",
        ";\n  color: ",
        ";\n  margin-bottom: 8px;\n  margin-top: 8px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    button {\n      svg {\n        height: 33px;\n        width: 33px;\n      }\n    }\n\n    button:not(:last-child) {\n      height: 40px;\n      width: 40px;\n      margin-right: 8px;\n    }\n  "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-around;\n  width: 80%;\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 10px;\n      height: 10px;\n    "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: 50%;\n  height: 100%;\n  transform: translate(-50%, 10%);\n  opacity: ",
        ";\n  span {\n    background-color: ",
        ";\n    width: 12px;\n    height: 12px;\n    ",
        "\n  }\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 60px;\n  "
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 50px;\n  "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 14px;\n    "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 68px;\n  height: 100%;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &:first-child {\n    background: #f5f1f2;\n  }\n  ",
        "\n  ",
        "\n\n  img {\n    width: 20px;\n    height: auto;\n    ",
        "\n    &.arrow {\n      width: 10px;\n      height: 9px;\n      opacity: 0.5;\n      transition: opacity 0.25s ease;\n    }\n  }\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-left: 19px;\n  "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: 23px;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 60px;\n      line-height: 16px;\n    "
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    "
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 50px;\n      line-height: 14px;\n    "
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .save-select__btn {\n    position: relative;\n    padding: 0;\n    height: 68px;\n    width: 100%;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 20px;\n    letter-spacing: initial;\n    text-transform: initial;\n    color: ",
        ";\n    margin-top: 10px;\n    background-color: #ffffff;\n    border: 1px solid #f0f1f2;\n    border-radius: 6px;\n    transition: box-shadow 0.25s ease;\n    cursor: pointer;\n    &--loading {\n      ",
        " {\n        opacity: 0;\n      }\n    }\n    ",
        "\n    ",
        "\n    ",
        "\n\n    & > span {\n      display: flex;\n      justify-content: space-between;\n      height: 100%;\n    }\n\n    &:hover {\n      border-radius: 6px;\n      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);\n      overflow: hidden;\n      transition: box-shadow 0.25s ease;\n\n      ",
        " {\n        .arrow {\n          opacity: 1;\n          transition: opacity 0.25s ease;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}


var Modal = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject3(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject1()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject2()));
var Wrapper = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject5(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.xSmallScreen */ .BC.xSmallScreen(_templateObject4()));
var Header = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject6());
var Content = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject13(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " auto ").concat(spacing.spacer, " auto");
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject7()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject8()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject9()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject10()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject11()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject12()));
var Left = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject17(), function(param) {
    var colors = param.theme.colors;
    return colors.light;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject14()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject15()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.xSmallScreen */ .BC.xSmallScreen(_templateObject16()));
var Right = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject19(), function(props) {
    return props.fullWidth ? "100%" : "50%";
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject18()));
var Image = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.img */ .zo.img(_templateObject24(), function(param) {
    var theme = param.theme, fullWidth = param.fullWidth;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject23(), fullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject20(), theme.spacing.spacer), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject21()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject22()));
});
var Title = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.h4 */ .zo.h4(_templateObject28(), function(param) {
    var typography = param.theme.typography;
    return typography.thinFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.h5FontSize;
}, function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 2.5)");
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject25()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject26()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject27()));
var Text = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .zo.p(_templateObject32(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 4)");
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject29(), function(param) {
    var spacing = param.theme.spacing;
    return spacing.spacer;
}), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject30(), function(param) {
    var spacing = param.theme.spacing;
    return spacing.spacer;
}), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.xSmallScreen */ .BC.xSmallScreen(_templateObject31(), function(param) {
    var spacing = param.theme.spacing;
    return "calc(".concat(spacing.spacer, " * 0.7)");
}));
var ContentWishlist = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject33());
var ProductImage = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.img */ .zo.img(_templateObject35(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.xSmallScreen */ .BC.xSmallScreen(_templateObject34()));
var ProductTitle = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .zo.p(_templateObject39(), function(param) {
    var typography = param.theme.typography;
    return typography.h4FontSize;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject36()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject37()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject38()));
var ProductCategory = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .zo.p(_templateObject43(), function(param) {
    var typography = param.theme.typography;
    return typography.extraFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.smallFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.graySemi;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject40()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject41()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject42()));
var ShareIconsWrapper = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject45(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject44()));
var SaveButton = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject47(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject46(), function(param) {
    var spacing = param.theme.spacing;
    return spacing.spacer;
}));
var SaveSelectLoader = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject49(), function(param) {
    var loading = param.loading;
    return loading ? 1 : 0;
}, function(param) {
    var colors = param.theme.colors;
    return colors.red;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject48()));
var SaveSelectIcon = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject53(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject50()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject51()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject52()));
var SaveSelectText = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject55(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject54()));
var SaveSelect = _styles__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .zo.div(_templateObject59(), function(param) {
    var typography = param.theme.typography;
    return typography.baseFontFamily;
}, function(param) {
    var typography = param.theme.typography;
    return typography.baseFontSize;
}, function(param) {
    var colors = param.theme.colors;
    return colors.baseFont;
}, SaveSelectText, _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.largeScreen */ .BC.largeScreen(_templateObject56()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject57()), _styles__WEBPACK_IMPORTED_MODULE_1__/* .media.smallScreen */ .BC.smallScreen(_templateObject58()), SaveSelectIcon);


/***/ })

}]);